import { Box, Flex } from '@chakra-ui/react';
import { Heading, colors } from 'ui-components';

import { PlatformDemographics } from './PlatformDemographics';

interface Props {
  isChartsDisabled: boolean;
  isBelowMinimumFollowers?: boolean;
}

export const DemographicsEmptyState: React.FC<Props> = ({
  isChartsDisabled,
  isBelowMinimumFollowers = false,
}) => {
  const getMessage = () => {
    if (isBelowMinimumFollowers) {
      return 'Metrics will be available once you reach the minimum follower requirement.';
    }
    return 'Audience demographics for this Talent are currently unavailable. Please try again later.';
  };

  return (
    <Box position="relative">
      <Flex
        width="100%"
        height="100%"
        zIndex={2}
        position="absolute"
        top={0}
        left={0}
        background={`linear-gradient(to bottom, transparent, ${colors.primary[0]} 80%, ${colors.primary[0]} 100%)`}
        alignItems="end"
      >
        <Flex
          flexDirection="column"
          maxWidth={708}
          mx="auto"
          justifyContent="center"
          textAlign="center"
          gap={6}
        >
          <Heading size="sm">{getMessage()}</Heading>
        </Flex>
      </Flex>
      <PlatformDemographics isDemographicsDisabled={isChartsDisabled} />
    </Box>
  );
};
